module.exports = __webpack_public_path__ + "75e3d5270e3ac3b0a6e24e161bab4090.svg";